import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['loadingLayer', 'generateButton', 'generateAlternativeButton', 'advertContent', 'advertTitle']

  static values = {
    url: String
  }

  generateAdvert = () => {
    this._disableButtons()
    this.populateAdvert({})
  }

  generateAlternativeAdvert = () => {
    this._disableButtons()
    this.populateAdvert({ variant: 'low_similarity' })
  }

  _disableButtons = () => {
    this.loadingLayerTarget.classList.remove('hidden')
    if (this.hasGenerateButtonTarget) this.generateButtonTarget.disabled = true
    if (this.hasGenerateAlternativeButtonTarget) this.generateAlternativeButtonTarget.disabled = true
  }

  _enableButtons = () => {
    if (this.hasGenerateButtonTarget) this.generateButtonTarget.disabled = false
    if (this.hasGenerateAlternativeButtonTarget) this.generateAlternativeButtonTarget.disabled = false
    this.loadingLayerTarget.classList.add('hidden')
  }

  populateAdvert = (body) => {
    fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token':     document.getElementsByName('csrf-token')[0].getAttribute('content'),
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type':     'application/json',
          'Accept':           'application/json'
        },
        body:        JSON.stringify(body),
        credentials: 'same-origin'
      }).then((response) => {
        if (response.status == 200) {
          response.json().then(data => {
            this.advertTitleTarget.value = data.title;
            this.advertContentTarget.value = data.content;
            this._enableButtons()
          })
        } else {
          response.json().then(data => {
            if (document.getElementsByClassName('iziToast-capsule').length < 1) alertMessage(data['error'], 'error');
            this._enableButtons()
          });
        }
      }
    )
  }
}
